import React from "react";
import {Icon, Input, Popup} from "semantic-ui-react"
import ReactFromHtml from "../ReactFromHtml";

interface IProperties {
    item: {
        id: string;
        placeholder: string;
        description: string;
        pattern: string;
        secret: boolean;
    };
}

interface IState {
    isFloat: boolean;
    reactConverter : ReactFromHtml;
}

export default class FloatinLabelTextInput extends React.Component<IProperties, IState> {
    state: IState = {
        isFloat: false,
        reactConverter: new ReactFromHtml()
    };

    setFloat = (value : string) =>
    {
        if (value)
            this.setState({isFloat : true});
        else
            this.setState({isFloat : false});
    };


    render()
    {
        return (
            <div className="input-container">
                <Input id={this.props.item.id}
                    fluid
                    autoComplete={"off"}
                    type={"text"}
                    className={this.props.item.secret ? "password" : ""}
                    pattern={this.props.item.pattern}
                    required={true}
                    onChange={e => this.setFloat( e.target.value)}
                    icon={<Popup trigger={<Icon name='info circle' link />}
                    content={this.state.reactConverter.parseToFragment(this.props.item.description)}
                    on={'click'}
                    position={'top right'}
                    hideOnScroll/>}/>
                <label className={this.state.isFloat ? 'filled' : ''}>{this.props.item.placeholder}</label>
            </div>
        );
    }
}